import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Badge } from "./ui/badge";

interface PendingRequestsBadgeProps {
  userId: string;
}

const PendingRequestsBadge = ({ userId }: PendingRequestsBadgeProps) => {
  const { data: pendingCount = 0 } = useQuery({
    queryKey: ["pending-follow-requests-count", userId],
    queryFn: async () => {
      // Get pending follow requests for the current user
      const { data: requests, error } = await supabase
        .from("follow_requests")
        .select("id, requester_id")
        .eq("target_user_id", userId)
        .eq("status", "pending");

      if (error) throw error;
      if (!requests?.length) return 0;

      // Filter out soft-deleted users
      const userIds = requests.map(r => r.requester_id);
      const { data: activeUserIds } = await supabase.rpc('get_active_user_ids', {
        user_ids: userIds
      });
      
      const activeSet = new Set(activeUserIds || []);
      const activeRequests = requests.filter((req: any) => activeSet.has(req.requester_id));
      
      return activeRequests.length;
    },
    refetchInterval: 30000, // Refresh every 30 seconds
  });

  if (pendingCount === 0) return null;

  return (
    <Badge 
      variant="destructive" 
      className="absolute -top-1 -right-1 h-5 w-5 rounded-full p-0 flex items-center justify-center text-xs"
    >
      {pendingCount}
    </Badge>
  );
};

export default PendingRequestsBadge;
